import React from 'react'
import PropTypes from 'prop-types'
import {isPortrait} from '../orientation'
import {View, Text, StyleSheet, TextInput, Image} from 'react-native'
import {CloseButton} from './close'

type Props = {
  /** The full length SKU of the line item */
  sku: String,
  /** sku quantity */
  quantity: number,
  /** The title to display in the RFQ cart */
  title: String,
  /** If fisher use a different image URL */
  fisher: boolean,
  /** Delete the line item. */
  onDeleteCartItem: Function,
  /** Callback for when the quantity is changed */
  onQuantityChange: Function,
}

export const RequestQuoteLineItem = ({sku, quantity, title, fisher, onDeleteCartItem, onQuantityChange}: Props) => {
  const url = "https://ecomseating.s3.amazonaws.com/images/320px/"
  + (fisher === true ? "fisher" : "standard") + "/" + sku + ".png"

  return (
    <View
      style={styles.container}
    >
      <Image style={styles.image} source={{uri: url}} />
      <View>
        <View style={{display: "flex", flexDirection: "row", alignItems: "center"}}>

          <TextInput
            style={styles.quantity}
            value={quantity.toString()}
            onChangeText={e => {
              console.log(e)
              if (parseInt(e)) {
                onQuantityChange(sku, parseInt(e))
              } else if (e == "") {
                onQuantityChange(sku, 0)
              }
            }}
            keyboardType="numeric"
          >
          </TextInput>
          <CloseButton onClick={e => onDeleteCartItem(sku)} />
        </View>
        <Text style={styles.sku}>SKU: {sku}</Text>
        <Text style={styles.title}>{title}</Text>
      </View>
    </View>
  )
}

RequestQuoteLineItem.propTypes = {
  sku: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  fisher: PropTypes.bool.isRequired,
  onDeleteCartItem: PropTypes.func.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'center',
    margin: 10,
    width: '100%',
  },
  title: {
    maxWidth: isPortrait() ? 'fit-content' : 400,
    margin: 10,
    overflow: 'hidden',
  },
  sku: {
    fontWeight: 'bold',
    margin: 10,
    maxWidth: '50%'
  },
  quantity: {
    width: 50,
    backgroundColor: 'white',
    padding: 10,
    margin: 10,
  },
  image: {
    minWidth: 120,
    minHeight: 160,
    margin: 10,
  },
})
